import type { DealEventLogControllerGetDealEventsData } from '@dealstack/shared/lib/backendClient';

export enum DealEventLogTab {
	ALL_EVENTS = 'ALL_EVENTS',
	INVESTOR_ACTIVITY = 'INVESTOR_ACTIVITY',
	CAPITAL_EVENTS = 'CAPITAL_EVENTS',
	TEAM_AND_ACCESS = 'TEAM_AND_ACCESS',
	MESSAGING = 'MESSAGING',
}

/** The feed's own query, minus the paging the hook owns — so it tracks the API as it grows. */
export type DealEventLogQuery = Omit<
	NonNullable<DealEventLogControllerGetDealEventsData['query']>,
	'cursor' | 'limit'
>;

export interface DealEventMessageState {
	eventLogSearch: string;
}
